/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepMetadata } from './StepMetadata';
import {
    StepMetadataFromJSON,
    StepMetadataFromJSONTyped,
    StepMetadataToJSON,
    StepMetadataToJSONTyped,
} from './StepMetadata';
import type { Task } from './Task';
import {
    TaskFromJSON,
    TaskFromJSONTyped,
    TaskToJSON,
    TaskToJSONTyped,
} from './Task';
import type { ServiceRole } from './ServiceRole';
import {
    ServiceRoleFromJSON,
    ServiceRoleFromJSONTyped,
    ServiceRoleToJSON,
    ServiceRoleToJSONTyped,
} from './ServiceRole';
import type { ServiceAgreementEditBlockedReason } from './ServiceAgreementEditBlockedReason';
import {
    ServiceAgreementEditBlockedReasonFromJSON,
    ServiceAgreementEditBlockedReasonFromJSONTyped,
    ServiceAgreementEditBlockedReasonToJSON,
    ServiceAgreementEditBlockedReasonToJSONTyped,
} from './ServiceAgreementEditBlockedReason';
import type { ServiceModel } from './ServiceModel';
import {
    ServiceModelFromJSON,
    ServiceModelFromJSONTyped,
    ServiceModelToJSON,
    ServiceModelToJSONTyped,
} from './ServiceModel';
import type { ServiceAgreementMetadata } from './ServiceAgreementMetadata';
import {
    ServiceAgreementMetadataFromJSON,
    ServiceAgreementMetadataFromJSONTyped,
    ServiceAgreementMetadataToJSON,
    ServiceAgreementMetadataToJSONTyped,
} from './ServiceAgreementMetadata';
import type { ServiceAgreementV2MacroStepListInner } from './ServiceAgreementV2MacroStepListInner';
import {
    ServiceAgreementV2MacroStepListInnerFromJSON,
    ServiceAgreementV2MacroStepListInnerFromJSONTyped,
    ServiceAgreementV2MacroStepListInnerToJSON,
    ServiceAgreementV2MacroStepListInnerToJSONTyped,
} from './ServiceAgreementV2MacroStepListInner';
import type { WaiverType } from './WaiverType';
import {
    WaiverTypeFromJSON,
    WaiverTypeFromJSONTyped,
    WaiverTypeToJSON,
    WaiverTypeToJSONTyped,
} from './WaiverType';
import type { DocumentV2 } from './DocumentV2';
import {
    DocumentV2FromJSON,
    DocumentV2FromJSONTyped,
    DocumentV2ToJSON,
    DocumentV2ToJSONTyped,
} from './DocumentV2';
import type { PrivateBankingServiceDefinitionId } from './PrivateBankingServiceDefinitionId';
import {
    PrivateBankingServiceDefinitionIdFromJSON,
    PrivateBankingServiceDefinitionIdFromJSONTyped,
    PrivateBankingServiceDefinitionIdToJSON,
    PrivateBankingServiceDefinitionIdToJSONTyped,
} from './PrivateBankingServiceDefinitionId';
import type { ServiceAgreementModification } from './ServiceAgreementModification';
import {
    ServiceAgreementModificationFromJSON,
    ServiceAgreementModificationFromJSONTyped,
    ServiceAgreementModificationToJSON,
    ServiceAgreementModificationToJSONTyped,
} from './ServiceAgreementModification';
import type { ProductSpecificServiceAgreementProperties } from './ProductSpecificServiceAgreementProperties';
import {
    ProductSpecificServiceAgreementPropertiesFromJSON,
    ProductSpecificServiceAgreementPropertiesFromJSONTyped,
    ProductSpecificServiceAgreementPropertiesToJSON,
    ProductSpecificServiceAgreementPropertiesToJSONTyped,
} from './ProductSpecificServiceAgreementProperties';

/**
 * 
 * @export
 * @interface ServiceAgreementV2
 */
export interface ServiceAgreementV2 {
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    serviceAgreementId?: string;
    /**
     * status of the service agreement
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    agreementStatus?: string;
    /**
     * Whether the business relation still holds this agreement. False once it is inactive, withdrawn, deleted or expired. Derived from agreementStatus so clients do not need to know which statuses mean the product has ended.
     * @type {boolean}
     * @memberof ServiceAgreementV2
     */
    isAlive?: boolean;
    /**
     * 
     * @type {Array<ServiceAgreementV2MacroStepListInner>}
     * @memberof ServiceAgreementV2
     */
    macroStepList?: Array<ServiceAgreementV2MacroStepListInner>;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    serviceDefinitionUuid?: string;
    /**
     * 
     * @type {PrivateBankingServiceDefinitionId}
     * @memberof ServiceAgreementV2
     */
    serviceDefinitionId?: PrivateBankingServiceDefinitionId;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    serviceDefinitionName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    family?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    category?: string;
    /**
     * 
     * @type {WaiverType}
     * @memberof ServiceAgreementV2
     */
    waiverType?: WaiverType;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    partnerId?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceAgreementV2
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    brProxyId?: string;
    /**
     * json metadata saved for this service agreement
     * @type {Array<ServiceAgreementMetadata>}
     * @memberof ServiceAgreementV2
     */
    attributes?: Array<ServiceAgreementMetadata>;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    processInstanceId?: string;
    /**
     * creator
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    createdBy?: string;
    /**
     * last modifier
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    modifiedBy?: string;
    /**
     * creation date
     * @type {Date}
     * @memberof ServiceAgreementV2
     */
    createdAt?: Date;
    /**
     * last modification date
     * @type {Date}
     * @memberof ServiceAgreementV2
     */
    modifiedAt?: Date;
    /**
     * define if this service agreement is from old or new (Flowable) flow
     * @type {boolean}
     * @memberof ServiceAgreementV2
     */
    isOldServiceAgreement?: boolean;
    /**
     * portfolio number, valid only for certain product
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    portfolioNumber?: string;
    /**
     * 
     * @type {Array<StepMetadata>}
     * @memberof ServiceAgreementV2
     */
    stepMetadata?: Array<StepMetadata>;
    /**
     * 
     * @type {Array<ServiceRole>}
     * @memberof ServiceAgreementV2
     */
    serviceRoles?: Array<ServiceRole>;
    /**
     * task history for this service agreement
     * @type {Array<Task>}
     * @memberof ServiceAgreementV2
     */
    tasks?: Array<Task>;
    /**
     * distributed documents for this service agreement
     * @type {Array<DocumentV2>}
     * @memberof ServiceAgreementV2
     */
    documents?: Array<DocumentV2>;
    /**
     * define if this service agreement can be closed by the current user
     * @type {boolean}
     * @memberof ServiceAgreementV2
     */
    canBeClosed?: boolean;
    /**
     * process instance Id for current active (if-any) closing process
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    closingProcessInstanceId?: string;
    /**
     * creation date
     * @type {Date}
     * @memberof ServiceAgreementV2
     */
    closureDate?: Date;
    /**
     * date when the service agreement was first activated
     * @type {Date}
     * @memberof ServiceAgreementV2
     */
    activeSince?: Date;
    /**
     * process instance Id for current active (if-any) modification process
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    modificationProcessInstanceId?: string;
    /**
     * used for active service agreements' modifications.
     * @type {boolean}
     * @memberof ServiceAgreementV2
     */
    canBeModified?: boolean;
    /**
     * define if the overview Edit action is available for this service agreement
     * @type {boolean}
     * @memberof ServiceAgreementV2
     */
    canBeEdited?: boolean;
    /**
     * 
     * @type {ServiceAgreementEditBlockedReason}
     * @memberof ServiceAgreementV2
     */
    editBlockedReason?: ServiceAgreementEditBlockedReason;
    /**
     * true if current user can abort an ongoing service agreement modification.
     * @type {boolean}
     * @memberof ServiceAgreementV2
     */
    canWithdrawModification?: boolean;
    /**
     * 
     * @type {Array<ServiceAgreementModification>}
     * @memberof ServiceAgreementV2
     */
    modificationList?: Array<ServiceAgreementModification>;
    /**
     * planned closure date
     * @type {Date}
     * @memberof ServiceAgreementV2
     */
    plannedClosureDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    processInstanceDefinitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    repaperingProcessInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    parentAgreement?: string;
    /**
     * Linked portfolio id when a portfolio exists for this service agreement; null otherwise.
     * @type {string}
     * @memberof ServiceAgreementV2
     */
    portfolioID?: string;
    /**
     * 
     * @type {ServiceModel}
     * @memberof ServiceAgreementV2
     */
    serviceModel?: ServiceModel;
    /**
     * 
     * @type {ServiceModel}
     * @memberof ServiceAgreementV2
     */
    draftServiceModel?: ServiceModel;
    /**
     * 
     * @type {ProductSpecificServiceAgreementProperties}
     * @memberof ServiceAgreementV2
     */
    productSpecificProperties?: ProductSpecificServiceAgreementProperties;
}



/**
 * Check if a given object implements the ServiceAgreementV2 interface.
 */
export function instanceOfServiceAgreementV2(value: object): value is ServiceAgreementV2 {
    return true;
}

export function ServiceAgreementV2FromJSON(json: any): ServiceAgreementV2 {
    return ServiceAgreementV2FromJSONTyped(json, false);
}

export function ServiceAgreementV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceAgreementId': json['serviceAgreementId'] == null ? undefined : json['serviceAgreementId'],
        'agreementStatus': json['agreementStatus'] == null ? undefined : json['agreementStatus'],
        'isAlive': json['isAlive'] == null ? undefined : json['isAlive'],
        'macroStepList': json['macroStepList'] == null ? undefined : ((json['macroStepList'] as Array<any>).map(ServiceAgreementV2MacroStepListInnerFromJSON)),
        'serviceDefinitionUuid': json['serviceDefinitionUuid'] == null ? undefined : json['serviceDefinitionUuid'],
        'serviceDefinitionId': json['serviceDefinitionId'] == null ? undefined : PrivateBankingServiceDefinitionIdFromJSON(json['serviceDefinitionId']),
        'serviceDefinitionName': json['serviceDefinitionName'] == null ? undefined : json['serviceDefinitionName'],
        'family': json['family'] == null ? undefined : json['family'],
        'category': json['category'] == null ? undefined : json['category'],
        'waiverType': json['waiverType'] == null ? undefined : WaiverTypeFromJSON(json['waiverType']),
        'partnerId': json['partnerId'] == null ? undefined : json['partnerId'],
        'version': json['version'] == null ? undefined : json['version'],
        'brProxyId': json['brProxyId'] == null ? undefined : json['brProxyId'],
        'attributes': json['attributes'] == null ? undefined : ((json['attributes'] as Array<any>).map(ServiceAgreementMetadataFromJSON)),
        'processInstanceId': json['processInstanceId'] == null ? undefined : json['processInstanceId'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'modifiedBy': json['modifiedBy'] == null ? undefined : json['modifiedBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
        'isOldServiceAgreement': json['isOldServiceAgreement'] == null ? undefined : json['isOldServiceAgreement'],
        'portfolioNumber': json['portfolioNumber'] == null ? undefined : json['portfolioNumber'],
        'stepMetadata': json['stepMetadata'] == null ? undefined : ((json['stepMetadata'] as Array<any>).map(StepMetadataFromJSON)),
        'serviceRoles': json['serviceRoles'] == null ? undefined : ((json['serviceRoles'] as Array<any>).map(ServiceRoleFromJSON)),
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(TaskFromJSON)),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentV2FromJSON)),
        'canBeClosed': json['canBeClosed'] == null ? undefined : json['canBeClosed'],
        'closingProcessInstanceId': json['closingProcessInstanceId'] == null ? undefined : json['closingProcessInstanceId'],
        'closureDate': json['closureDate'] == null ? undefined : (new Date(json['closureDate'])),
        'activeSince': json['activeSince'] == null ? undefined : (new Date(json['activeSince'])),
        'modificationProcessInstanceId': json['modificationProcessInstanceId'] == null ? undefined : json['modificationProcessInstanceId'],
        'canBeModified': json['canBeModified'] == null ? undefined : json['canBeModified'],
        'canBeEdited': json['canBeEdited'] == null ? undefined : json['canBeEdited'],
        'editBlockedReason': json['editBlockedReason'] == null ? undefined : ServiceAgreementEditBlockedReasonFromJSON(json['editBlockedReason']),
        'canWithdrawModification': json['canWithdrawModification'] == null ? undefined : json['canWithdrawModification'],
        'modificationList': json['modificationList'] == null ? undefined : ((json['modificationList'] as Array<any>).map(ServiceAgreementModificationFromJSON)),
        'plannedClosureDate': json['plannedClosureDate'] == null ? undefined : (new Date(json['plannedClosureDate'])),
        'processInstanceDefinitionId': json['processInstanceDefinitionId'] == null ? undefined : json['processInstanceDefinitionId'],
        'repaperingProcessInstanceId': json['repaperingProcessInstanceId'] == null ? undefined : json['repaperingProcessInstanceId'],
        'parentAgreement': json['parentAgreement'] == null ? undefined : json['parentAgreement'],
        'portfolioID': json['portfolioID'] == null ? undefined : json['portfolioID'],
        'serviceModel': json['serviceModel'] == null ? undefined : ServiceModelFromJSON(json['serviceModel']),
        'draftServiceModel': json['draftServiceModel'] == null ? undefined : ServiceModelFromJSON(json['draftServiceModel']),
        'productSpecificProperties': json['productSpecificProperties'] == null ? undefined : ProductSpecificServiceAgreementPropertiesFromJSON(json['productSpecificProperties']),
    };
}

export function ServiceAgreementV2ToJSON(json: any): ServiceAgreementV2 {
    return ServiceAgreementV2ToJSONTyped(json, false);
}

export function ServiceAgreementV2ToJSONTyped(value?: ServiceAgreementV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceAgreementId': value['serviceAgreementId'],
        'agreementStatus': value['agreementStatus'],
        'isAlive': value['isAlive'],
        'macroStepList': value['macroStepList'] == null ? undefined : ((value['macroStepList'] as Array<any>).map(ServiceAgreementV2MacroStepListInnerToJSON)),
        'serviceDefinitionUuid': value['serviceDefinitionUuid'],
        'serviceDefinitionId': PrivateBankingServiceDefinitionIdToJSON(value['serviceDefinitionId']),
        'serviceDefinitionName': value['serviceDefinitionName'],
        'family': value['family'],
        'category': value['category'],
        'waiverType': WaiverTypeToJSON(value['waiverType']),
        'partnerId': value['partnerId'],
        'version': value['version'],
        'brProxyId': value['brProxyId'],
        'attributes': value['attributes'] == null ? undefined : ((value['attributes'] as Array<any>).map(ServiceAgreementMetadataToJSON)),
        'processInstanceId': value['processInstanceId'],
        'createdBy': value['createdBy'],
        'modifiedBy': value['modifiedBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
        'isOldServiceAgreement': value['isOldServiceAgreement'],
        'portfolioNumber': value['portfolioNumber'],
        'stepMetadata': value['stepMetadata'] == null ? undefined : ((value['stepMetadata'] as Array<any>).map(StepMetadataToJSON)),
        'serviceRoles': value['serviceRoles'] == null ? undefined : ((value['serviceRoles'] as Array<any>).map(ServiceRoleToJSON)),
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(TaskToJSON)),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentV2ToJSON)),
        'canBeClosed': value['canBeClosed'],
        'closingProcessInstanceId': value['closingProcessInstanceId'],
        'closureDate': value['closureDate'] == null ? value['closureDate'] : value['closureDate'].toISOString(),
        'activeSince': value['activeSince'] == null ? value['activeSince'] : value['activeSince'].toISOString(),
        'modificationProcessInstanceId': value['modificationProcessInstanceId'],
        'canBeModified': value['canBeModified'],
        'canBeEdited': value['canBeEdited'],
        'editBlockedReason': ServiceAgreementEditBlockedReasonToJSON(value['editBlockedReason']),
        'canWithdrawModification': value['canWithdrawModification'],
        'modificationList': value['modificationList'] == null ? undefined : ((value['modificationList'] as Array<any>).map(ServiceAgreementModificationToJSON)),
        'plannedClosureDate': value['plannedClosureDate'] == null ? value['plannedClosureDate'] : value['plannedClosureDate'].toISOString().substring(0,10),
        'processInstanceDefinitionId': value['processInstanceDefinitionId'],
        'repaperingProcessInstanceId': value['repaperingProcessInstanceId'],
        'parentAgreement': value['parentAgreement'],
        'portfolioID': value['portfolioID'],
        'serviceModel': ServiceModelToJSON(value['serviceModel']),
        'draftServiceModel': ServiceModelToJSON(value['draftServiceModel']),
        'productSpecificProperties': ProductSpecificServiceAgreementPropertiesToJSON(value['productSpecificProperties']),
    };
}

